function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1908(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 21.12,
    height: 5.16,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.86
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.56,
    y: 2.58
  }, "\n        Alpine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 5.16,
    width: 21.12,
    height: 22.44,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.28
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.56,
    y: 16.380000000000003
  }, "\n        Mono\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 27.6,
    width: 21.12,
    height: 45.54,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.3466666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.56,
    y: 50.370000000000005
  }, "\n        Del_Norte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 73.14,
    width: 21.12,
    height: 53.1,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.0171428571428573
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.56,
    y: 99.69
  }, "\n        Trinity\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 126.25,
    width: 21.12,
    height: 57.3,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.64
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.56,
    y: 154.9
  }, "\n        Mariposa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 183.55,
    width: 21.12,
    height: 60.54,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.52
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.56,
    y: 213.82000000000002
  }, "\n        Lassen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 244.09,
    width: 21.12,
    height: 64.98,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.52
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.56,
    y: 276.58
  }, "\n        Sierra\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 309.08,
    width: 21.12,
    height: 68.28,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.52
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.56,
    y: 343.21999999999997
  }, "\n        Plumas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 377.36,
    width: 21.12,
    height: 74.52,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.224
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.56,
    y: 414.62
  }, "\n        Modoc\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 451.89,
    width: 21.12,
    height: 79.74,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.52
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.56,
    y: 491.76
  }, "\n        Madera\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 531.63,
    width: 21.12,
    height: 82.92,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.224
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.56,
    y: 573.09
  }, "\n        Glenn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 614.56,
    width: 21.12,
    height: 85.44,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.28
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.56,
    y: 657.28
  }, "\n        Inyo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.12,
    y: 0,
    width: 37.21,
    height: 49.69,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.3025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.725,
    y: 24.845
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.33,
    y: 0,
    width: 41.6,
    height: 49.69,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.933333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.13,
    y: 24.845
  }, "\n        Sutter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99.93,
    y: 0,
    width: 44.61,
    height: 49.69,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.461
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 122.23500000000001,
    y: 24.845
  }, "\n        San_Benito\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.53,
    y: 0,
    width: 48.25,
    height: 49.69,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.041666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 168.655,
    y: 24.845
  }, "\n        Colusa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 192.79,
    y: 0,
    width: 48.66,
    height: 49.69,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.0825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 217.12,
    y: 24.845
  }, "\n        Imperial\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 241.45,
    y: 0,
    width: 50.88,
    height: 49.69,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.281666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 266.89,
    y: 24.845
  }, "\n        Amador\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 292.33,
    y: 0,
    width: 54.17,
    height: 49.69,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.21125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 319.41499999999996,
    y: 24.845
  }, "\n        Tuolumne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 346.5,
    y: 0,
    width: 56.21,
    height: 49.69,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.521111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 374.605,
    y: 24.845
  }, "\n        El_Dorado\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 402.71,
    y: 0,
    width: 57.18,
    height: 49.69,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.281666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 431.29999999999995,
    y: 24.845
  }, "\n        Tehama\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 459.88,
    y: 0,
    width: 57.41,
    height: 49.69,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.937999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 488.585,
    y: 24.845
  }, "\n        Kings\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 517.29,
    y: 0,
    width: 58.63,
    height: 49.69,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.4225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 546.605,
    y: 24.845
  }, "\n        Yuba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 575.93,
    y: 0,
    width: 60.75,
    height: 49.69,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.521111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 606.305,
    y: 24.845
  }, "\n        Calaveras\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 636.67,
    y: 0,
    width: 63.33,
    height: 49.69,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.281666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 668.3349999999999,
    y: 24.845
  }, "\n        Merced\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.12,
    y: 49.69,
    width: 64.95,
    height: 64.29,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.184285714285716
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.595,
    y: 81.83500000000001
  }, "\n        Ventura\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.12,
    y: 113.99,
    width: 64.95,
    height: 67.96,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.2375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.595,
    y: 147.97
  }, "\n        Yolo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.12,
    y: 181.95,
    width: 64.95,
    height: 69.86,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.495
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.595,
    y: 216.88
  }, "\n        Stanislaus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.12,
    y: 251.81,
    width: 64.95,
    height: 70.01,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.825000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.595,
    y: 286.815
  }, "\n        Nevada\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.12,
    y: 321.82,
    width: 64.95,
    height: 70.73,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.825000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.595,
    y: 357.185
  }, "\n        Placer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.12,
    y: 392.56,
    width: 64.95,
    height: 74.64,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.11875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.595,
    y: 429.88
  }, "\n        Siskiyou\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.12,
    y: 467.19,
    width: 64.95,
    height: 77.19,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.33
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.595,
    y: 505.78499999999997
  }, "\n        San_Luis_Obispo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.12,
    y: 544.38,
    width: 64.95,
    height: 77.51,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.825000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.595,
    y: 583.135
  }, "\n        Shasta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.12,
    y: 621.89,
    width: 64.95,
    height: 78.11,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.99
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.595,
    y: 660.9449999999999
  }, "\n        Marin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.07,
    y: 49.69,
    width: 64.29,
    height: 80.25,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.0725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.215,
    y: 89.815
  }, "\n        Napa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 150.36,
    y: 49.69,
    width: 71.92,
    height: 80.25,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.9911111111111115
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 186.32000000000002,
    y: 89.815
  }, "\n        San_Mateo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222.28,
    y: 49.69,
    width: 73.2,
    height: 80.25,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.15
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 258.88,
    y: 89.815
  }, "\n        Monterey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 295.48,
    y: 49.69,
    width: 77.64,
    height: 80.25,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.972307692307693
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 334.3,
    y: 89.815
  }, "\n        Santa_Barbara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 373.11,
    y: 49.69,
    width: 78.05,
    height: 80.25,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.672222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 412.135,
    y: 89.815
  }, "\n        Mendocino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 451.16,
    y: 49.69,
    width: 78.61,
    height: 80.25,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 19.6525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 490.46500000000003,
    y: 89.815
  }, "\n        Kern\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 529.77,
    y: 49.69,
    width: 83.3,
    height: 80.25,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 571.42,
    y: 89.815
  }, "\n        Santa_Cruz\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 613.08,
    y: 49.69,
    width: 86.92,
    height: 80.25,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.6875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 656.5400000000001,
    y: 89.815
  }, "\n        Contra_Costa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.07,
    y: 129.95,
    width: 78.81,
    height: 90.72,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.756666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.475,
    y: 175.31
  }, "\n        Riverside\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.07,
    y: 220.66,
    width: 78.81,
    height: 91.55,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.135
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.475,
    y: 266.435
  }, "\n        Solano\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.07,
    y: 312.22,
    width: 78.81,
    height: 91.96,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.135
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.475,
    y: 358.20000000000005
  }, "\n        Tulare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.07,
    y: 404.17,
    width: 78.81,
    height: 94.34,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.762
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.475,
    y: 451.34000000000003
  }, "\n        Butte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.07,
    y: 498.51,
    width: 78.81,
    height: 97.09,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.135
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.475,
    y: 547.055
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.07,
    y: 595.6,
    width: 78.81,
    height: 104.4,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.85125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.475,
    y: 647.8000000000001
  }, "\n        Humboldt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 164.88,
    y: 129.95,
    width: 95.16,
    height: 114.06,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.65090909090909
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 212.45999999999998,
    y: 186.98
  }, "\n        San_Joaquin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 260.04,
    y: 129.95,
    width: 99.33,
    height: 114.06,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.095
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 309.70500000000004,
    y: 186.98
  }, "\n        San_Bernardino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 359.37,
    y: 129.95,
    width: 104.48,
    height: 114.06,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.60888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 411.61,
    y: 186.98
  }, "\n        San_Diego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 463.85,
    y: 129.95,
    width: 104.88,
    height: 114.06,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.48
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 516.29,
    y: 186.98
  }, "\n        Sonoma\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 568.73,
    y: 129.95,
    width: 131.27,
    height: 114.06,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.406
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 634.365,
    y: 186.98
  }, "\n        Sacramento\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 164.88,
    y: 244.01,
    width: 164.9,
    height: 96.42,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.07
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 247.32999999999998,
    y: 292.21999999999997
  }, "\n        Fresno\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 164.88,
    y: 340.43,
    width: 164.9,
    height: 103.77,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.433636363636364
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 247.32999999999998,
    y: 392.315
  }, "\n        Santa_Clara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 164.88,
    y: 444.2,
    width: 164.9,
    height: 255.8,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 23.557142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 247.32999999999998,
    y: 572.1
  }, "\n        Alameda\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 329.78,
    y: 244.01,
    width: 370.22,
    height: 205.82,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.832307692307692
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 514.89,
    y: 346.91999999999996
  }, "\n        San_Francisco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 329.78,
    y: 449.83,
    width: 370.22,
    height: 250.17,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 22.742727272727272
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 514.89,
    y: 574.915
  }, "\n        Los_Angeles\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1908);
export default __webpack_public_path__ + "static/media/1908.adf5acffc8885f94d9f9daeb1a394561.svg";
export { ForwardRef as ReactComponent };